import { SendMessageIcon } from 'static';
import styled, { css } from 'styled-components';
import {
  COMMUNITY_SIDEBAR_INDICATOR_LEFT,
  SIDEBAR_MENU_ITEM_PADDING_X,
  SIDEBAR_MENU_ROW_GAP,
  SIDEBAR_SPACE_4,
  SIDEBAR_SPACE_8,
  SIDEBAR_SPACE_12,
  SIDEBAR_SPACE_16,
  SIDEBAR_SPACE_24,
  sidebarMenuListItemHighlightAfter,
} from 'styles/sidebarMenuListItemHighlight';

import { pulse } from '../CommunityMenuList/styled';

export const StatusDot = styled.span<{ $active?: boolean }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${SIDEBAR_SPACE_12};
  height: ${SIDEBAR_SPACE_12};

  &::before {
    content: '';
    width: ${SIDEBAR_SPACE_8};
    height: ${SIDEBAR_SPACE_8};
    border-radius: 50%;
    background-color: ${({ theme, $active }) =>
      $active ? theme.color.brightTurquoise : theme.color.casper};
  }
`;

export const StyledMenuList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 2px;
  list-style-type: none;
  li:last-of-type {
    margin-bottom: 0;
  }
`;
export const IconSendMessage = styled(SendMessageIcon)`
  width: ${SIDEBAR_SPACE_16};
  height: ${SIDEBAR_SPACE_16};
  z-index: 10;
  path {
    stroke: ${({ theme }) => theme.color.pickledBluewood};
    stroke-width: 2;
  }
`;

export const ChatIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
  width: ${SIDEBAR_SPACE_24};
  height: ${SIDEBAR_SPACE_24};
  border-radius: 9999999px;
  opacity: 0;
  pointer-events: none;
  z-index: 2;

  &:hover {
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 99999px;
      border: 1px solid ${({ theme }) => theme.color.brightTurquoise};
      background: ${({ theme }) => theme.color.brightTurquoise};
      z-index: 0;
    }
  }

  &:hover ${IconSendMessage} {
    path {
      stroke: ${({ theme }) => theme.color.white};
      stroke-width: 2;
    }
  }
`;

export const StyledMenuListItem = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: ${SIDEBAR_MENU_ROW_GAP};
  cursor: pointer;
  padding: ${SIDEBAR_SPACE_4} ${SIDEBAR_MENU_ITEM_PADDING_X};
  align-items: center;
  font-size: 13px;
  border-radius: 6px;
  color: ${({ theme }) => theme.color.pickledBluewood};
  ${sidebarMenuListItemHighlightAfter({
    indicatorLeft: COMMUNITY_SIDEBAR_INDICATOR_LEFT,
  })}

  ${({ hasGreenDot }) =>
    hasGreenDot &&
    css`
      color: ${({ theme }) => theme.color.brightTurquoise};
      background-color: ${({ theme }) => theme.color.blackSqueeze};

      &::after {
        transform: translateY(-50%) scaleY(1);
      }
    `}

  &:hover {
    color: ${({ theme }) => theme.color.brightTurquoise};

    ${ChatIconWrapper} {
      opacity: 1;
      pointer-events: auto;
    }
  }

  ${({ isActive }) =>
    isActive &&
    css`
      color: ${({ theme }) => theme.color.brightTurquoise};
      background-color: ${({ theme }) => theme.color.blackSqueeze};

      &::after {
        transform: translateY(-50%) scaleY(1);
      }

      ${ChatIconWrapper} {
        opacity: 1;
        pointer-events: auto;
      }
    `}
`;

export const StyledName = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const NameAndBadgeWrapper = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  gap: ${SIDEBAR_SPACE_4};
`;

export const FlexBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ gap }) => gap || SIDEBAR_SPACE_4};
  min-height: ${SIDEBAR_SPACE_24};
  min-width: calc(
    ${SIDEBAR_SPACE_24} + ${SIDEBAR_SPACE_16} + ${SIDEBAR_SPACE_4}
  );
  flex-shrink: 0;
`;

export const MessageCount = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${SIDEBAR_SPACE_16};
  height: ${SIDEBAR_SPACE_16};
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.color.brightTurquoise};
  border-radius: 99999px;
  animation: ${pulse} 1s infinite;
`;

export const CountBadge = styled.div`
  display: flex;
  font-size: 10px;
  line-height: normal;
  border-radius: 9999999px;
  color: ${({ theme }) => theme.color.white}; ;
`;
